package kz.dentalcrm.app.expectations

import androidx.compose.runtime.Composable

@Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")
internal actual class ContactPicker actual constructor() {

    @Composable
    actual fun registerContactPicker(onContactSelected: (UserPhone?) -> Unit) {
        onContactSelected(null)
    }

    actual fun launchContactPicker() {
    }
}
